module.exports = __webpack_public_path__ + "static/img/m3_t2b_2.04861dd6.jpg";